import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconButton, SvgIcon, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldHalved } from "@fortawesome/pro-light-svg-icons";

export const AdminButton = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Tooltip title={t("client.admin")}>
      <IconButton
        onClick={() => navigate("/admin")}
        sx={{
          backgroundColor: pathname.startsWith("/admin")
            ? alpha(theme.palette.common.white, 0.1)
            : "transparent",
        }}
      >
        <SvgIcon>
          <FontAwesomeIcon color="white" icon={faShieldHalved} />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};
